export default "__VITE_ASSET__gIs3mvrQ__";